"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridCore = void 0;
const react_1 = __importStar(require("react"));
const GridCoreVirtualizedList_1 = require("./components/GridCoreVirtualizedList/GridCoreVirtualizedList");
const GridCore_styles_1 = require("./GridCore.styles");
const useGridCoreConfigure_1 = require("./hooks/useGridCoreConfigure");
const useScrollCallback_1 = require("./hooks/useScrollCallback");
const helpers_1 = require("../helpers");
exports.GridCore = react_1.default.memo(function GridCoreComponent({ getDataByIndex, totalItemsCount, idGetter, columns, plugins, columnsToggleable, footer, onItemsRendered }) {
    var _a;
    const rootRef = (0, react_1.useRef)(null);
    const size = (0, helpers_1.useResizeObserver)(rootRef);
    const vListApiRef = (0, react_1.useRef)(null);
    const listBodyRef = (0, react_1.useRef)(null);
    const [listBodyHeight, setListBodyHeight] = (0, react_1.useState)(null);
    const headerContainerRef = (0, react_1.useRef)(null);
    const onScroll = (0, useScrollCallback_1.useScrollCallback)({ headerRef: headerContainerRef });
    const gridApi = (0, react_1.useState)(() => {
        return {
            scrollTo: (index) => {
                var _a;
                (_a = vListApiRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(index);
            }
        };
    })[0];
    const { rowRenderer, header, rowWidth, rowHeightGetter, containerAddonRenderer, bodyAddonRenderer, subheaderAddonRenderer, hasColumns, rootClassNames } = (0, useGridCoreConfigure_1.useGridCoreConfigure)({
        rootRef,
        bodyRef: listBodyRef,
        idGetter,
        rootWidth: (_a = size.width) !== null && _a !== void 0 ? _a : 0,
        listBodyHeight,
        getDataByIndex,
        headerContainerRef,
        columns,
        plugins,
        totalItemsCount,
        gridApi,
        columnsToggleable
    });
    const hasRows = (0, react_1.useMemo)(() => Boolean(totalItemsCount > 0), [totalItemsCount]);
    const rowsHeight = (0, react_1.useMemo)(() => rowHeightGetter(0), [rowHeightGetter]);
    const itemKey = (0, react_1.useCallback)((index) => {
        const data = getDataByIndex(index);
        if (data === null) {
            return `row-skeleton-${index}`;
        }
        return `row-${idGetter(data)}`;
    }, [getDataByIndex, idGetter]);
    const onHeightChangeHandler = (0, react_1.useCallback)((height) => {
        setListBodyHeight((prevHeight) => (prevHeight !== height ? height : prevHeight));
    }, []);
    if (!size.width || !size.height) {
        return react_1.default.createElement(GridCore_styles_1.StyledGridCore, { ref: rootRef });
    }
    return (react_1.default.createElement(GridCore_styles_1.StyledGridCore, { ref: rootRef, className: (0, helpers_1.cn)('vm-GridCore', ...rootClassNames) },
        header,
        react_1.default.createElement(GridCore_styles_1.StyledGridCoreWrapper, { style: { minWidth: size.width } },
            hasColumns && (react_1.default.createElement(react_1.default.Fragment, null,
                subheaderAddonRenderer(),
                react_1.default.createElement(GridCoreVirtualizedList_1.GridCoreVirtualizedList, { apiRef: vListApiRef, wrapperRef: listBodyRef, rowRenderer: rowRenderer, rowWidth: rowWidth, rowHeight: rowsHeight, itemCount: totalItemsCount, itemKey: itemKey, onScroll: onScroll, onItemsRendered: onItemsRendered, onHeightChange: onHeightChangeHandler }))),
            bodyAddonRenderer()),
        hasRows && hasColumns && footer,
        containerAddonRenderer()));
});
//# sourceMappingURL=GridCore.js.map